import i18next from 'i18next';
import { APP_NAMESPACE } from '@/_constants/i18next/app-namespace';
import { I18N_DICTIONARY } from './translates/dictionary';

export const backendErrorsSubnamespace = 'backend-errors';

export const i18nextNSInit = (locale: string) => {
  const wasResourceDownloaded = Boolean(
    i18next.getResourceBundle(locale, APP_NAMESPACE),
  );

  if (wasResourceDownloaded) {
    return;
  }

  Object.entries(I18N_DICTIONARY).forEach(([currentLocale, translates]) =>
    i18next.addResourceBundle(currentLocale, APP_NAMESPACE, translates),
  );
};
